<template>
  <section class="dashboard-container">
    <h1 class="dashboard-title">Administración general</h1>
    <div class="dashboard-card"></div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminDashboardPage",
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters({
      business: "app/getBusiness",
      showViewAdmin: "app/getShowViewAdmin",
    }),
  },
};
</script>

<style lang="stylus" scoped>
@import "../Styles/Dashboard.styl"
</style>
